import { LoginContext, LoginProvider } from './context'
import { LoginForm } from './ui'

export const Login = {
    Context: LoginContext,
    Provider: LoginProvider,
    Form: LoginForm,
}
